/**
* Project Name : cop-web-portal
* File Name : EmptyPage.vue
* Description : Warning page when error occurs
* Date : 2023.05.12
*/
<template>
  <div class="message_wrap">
    <!-- login -->
    <div v-if="pageDesign === 'login'"
         class="error_msg_wrap"
    >
      <!--
      <header class="mb-4">
        <img :src="$CONTEXT + '/static/image/main/simbol.png'" class="mb-3 ui--brand-simbol" alt="System Simbol" />
        <router-link :to="{ name: 'mainIndexPage' }" tag="span" class="brand-text cursor-pointer">
          {{ title }}
        </router-link>
      </header>
      -->
      <h5>{{ message }}</h5>
      <p>{{ $t('sdl.common.label.reloginmsg') }}</p>
      <p v-html="$t('cop.warning.message.common.scopWillServe')"></p>
      <p>{{ $t('cop.warning.message.common.notEffected') }}</p>
      <p>{{ $t('cop.warning.message.common.askNumber1') }}</p>
      <span>{{ $t('cop.warning.message.common.askNumber2') }}</span><span class="move_target" @click="moveItVoc()">{{ systemItvoc }}</span><br/>
      <span>{{ systemPropMsg }}</span>
      <br>
      <button class="btn btn-lg btn-primary" @click="goLogin">{{
        $t('sdl.common.label.loginshortcut')}}
      </button>
      <button class="btn btn-lg btn-primary" @click="showErrMsg(msg)" v-if="showErrMsgYn">{{ $t('cop.common.error-msg') }}</button>
    </div>
    <!-- login else -->
    <div v-else-if="pageDesign === 'inactive'"
         class="error_msg_wrap"
    >
      <template v-if="pageDesign === 'inactive' && errorCode === '192'">
        <h5>{{ message }}</h5>
        <p>{{$t('cop.warning.message.content.reconnect1')}}</p>
        <p style="align-items:center;">{{$t('cop.warning.message.content.reconnect2')}}
          <button style="margin-top:0;height:25px;margin-left:10px" class="btn btn-lg btn-primary" @click="activate">{{$t('cop.warning.message.button.activate')}}</button>
        </p>
        <p style="color:red;font-weight:500;">{{ $t('cop.warning.message.long-term.send-mail-message1') }}</p>
        <p style="color:red;font-weight:500;">{{ $t('cop.warning.message.long-term.send-mail-message2') }}</p>
        <p>{{ $t('cop.warning.message.common.askNumber1') }}</p>
        <span>{{ $t('cop.warning.message.common.askNumber2') }}</span><span class="move_target" @click="moveItVoc()">{{ systemItvoc }}</span><br/>
        <span>{{ systemPropMsg }}</span>
        <a href="javascript:">{{ $t('sdl.common.projectHelp') }}</a>
      </template>
      <template v-else-if="pageDesign === 'inactive'">
        <h5>{{ message }}</h5>
        <p>{{ $t('sdl.commonError') }}</p>
        <p v-html="$t('cop.warning.message.common.scopWillServe')"></p>
        <p>{{ $t('cop.warning.message.common.notEffected') }}</p>
        <p>{{ $t('cop.warning.message.common.askNumber1') }}</p>
        <span>{{ $t('cop.warning.message.common.askNumber2') }}</span><span class="move_target" @click="moveItVoc()">{{ systemItvoc }}</span><br/>
        <span>{{ systemPropMsg }}</span>
        <a href="javascript:">{{ $t('sdl.common.projectHelp') }}</a>
      </template>
      <template v-else>
        <h4>{{ errorTitle }}</h4>
        <h5>{{ message }}</h5>
        <p>{{ $t('sdl.common.label.goMainPage') }}</p>
        <button class="btn btn-lg btn-primary" type="button" @click="goMain">
          {{ $t('sdl.common.label.mainShortcut') }}
        </button>
        <a href="javascript:">{{ $t('sdl.common.projectHelp') }}</a>
        <br/>
        <button class="btn btn-lg btn-primary" @click="activate">Activate</button>
      </template>
      <button class="btn btn-lg btn-primary" @click="showErrMsg(msg)" v-if="showErrMsgYn">{{ $t('cop.common.error-msg') }}</button>
    </div>

    <div v-else-if="pageDesign === 'clientServerErr'"
        class="error_msg_wrap"
    >
        <h5>{{ titleMessage }}</h5>
        <p>{{ message }}</p>
        <p v-html="$t('cop.warning.message.common.scopWillServe')"></p>
        <p>{{ $t('cop.warning.message.common.notEffected') }}</p>
        <p>{{ $t('cop.warning.message.common.askNumber1') }}</p>
        <span>{{ $t('cop.warning.message.common.askNumber2') }}</span><span class="move_target" @click="moveItVoc()">{{ systemItvoc }}</span><br/>
        <span>{{ systemPropMsg }}</span>
        <a href="javascript:">{{ $t('sdl.common.projectHelp') }}</a>
        <br>
        <button class="btn btn-lg btn-primary" @click="goBack" v-if="errorCode === '500'">{{
          $t('cop.warning.label.goBack')}}
        </button>
        <button class="btn btn-lg btn-primary" @click="$router.push('/')" v-else>{{$t('cop.warning.label.goHome')}}</button>
        <button class="btn btn-lg btn-primary" @click="showErrMsg(msg)" v-if="showErrMsgYn">{{ $t('cop.common.error-msg') }}</button>
    </div>

    <!--
    <footer v-if="pageDesign === 'login'"
            class="login_footer"
    >
        <p class="text-muted">
          {{ $t('sdl.common.message.onlyAuthUserLegalSanctions') }}
        </p>
        <span>&copy; Samsung</span>
    </footer>
    <footer v-else
            class="login_footer"
    >
      <div class="ui--footer-in">
        <span>&copy; Samsung</span>
      </div>
    </footer>
    -->
  </div>
</template>

<script>
import { SDLUtil, RequestUtil } from '@/utils';
import { syslinkService } from '@/service';

export default {
  data() {
    return {
      message: SDLUtil.getMsgProp('sdl.commonError'),
      title: SDLUtil.getMsgProp('sdl.common.projectName'),
      pageDesign: 'common',
      titleMessage: '',
      errorCode: '',
      errorType: '',
      // 서버 에러메세지 추가
      msg: null,
      code: '',
      systemEmail: '',
      systemTel: '',
      systemItvoc: '',
    };
  },
  computed: {
    errorTitle() {
      const errorTitle = `${this.errorType}`;
      return errorTitle;
    },
    showErrMsgYn() {
      return this.msg;
    },
    systemPropMsg() {
      return SDLUtil.getMsgProp('cop.warning.message.common.askNumber3', [this.systemEmail, this.systemTel]);
    },
  },
  methods: {
    goLogin() {
      const redirect = this.$route.query.redirect || '';
      if (redirect) {
        this.$router.replace({ path: `${SDLUtil.WEB_CONTEXT_PATH}/login?redirect=${redirect}` });
      } else {
        this.$router.replace({ path: `${SDLUtil.WEB_CONTEXT_PATH}/login` });
      }
    },
    goMain() {
      this.$router.replace({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
    },
    goBack() {
      this.$router.go(-1);
    },
    showErrMsg(msg) {
      SDLUtil.alert({
        title: 'sdl.common.message.error',
        msg,
      });
    },
    // IT-VOC로 이동
    moveItVoc() {
      if (SDLUtil.isLogin()) syslinkService.openSysLink(`${this.systemItvoc}`); // 로그인시 접속로그 생성
      else window.open(this.systemItvoc, '_blank'); // 미로그인시 접속로그 미생성
    },
    activate() {
      RequestUtil
        .put(`${SDLUtil.API_URL}/auth/activate`)
        .then(() => {
          this.$router.push('/');
        });
    },
  },
  created() {
    this.code = this.$route.query.code;
    if (this.$route.path === '/noauth') this.code = '401';
    this.errorCode = this.code || '404';
    this.errorType = this.$route.query.errorType || 'Not Found';
    this.msg = this.$route.query.msg || null;

    const login = ['185', '187', '188', '190', '194', '195', '199', '202'];
    const inactive = ['191', '192', '193', '200', '203'];
    const clientServerErrCodes = ['400', '401', '403', '404', '500', '503'];

    const errList = [
      { code: '185', message: 'sdl.auth.message.user.notFound' },
      { code: '187', message: 'sdl.auth.message.token.retentionTimeout' },
      { code: '188', message: 'sdl.login.noUserInfoByIdEmail' },
      { code: '190', message: 'sdl.auth.message.user.notFound' },
      { code: '191', message: 'sdl.auth.message.user.waiting' },
      { code: '192', message: 'sdl.auth.message.user.inactive' },
      { code: '193', message: 'sdl.auth.message.user.deleted' },
      { code: '194', message: 'sdl.auth.message.token.invalid' },
      { code: '195', message: 'sdl.auth.message.token.notFound' },
      { code: '199', message: 'sdl.auth.message.duplicate.login' },
      { code: '200', message: 'sdl.auth.message.access.limit.exceeded' },
      { code: '202', message: 'sdl.common.message.knoxLoginFail' },
      { code: '203', message: 'sdl.auth.message.user.exceed.password' },
      { code: '400', message: 'cop.warning.message.content.badRequest', titleMessage: 'cop.warning.message.title.badRequest', errorType: 'Bad Request' },
      { code: '401', message: 'cop.warning.message.content.noauth', titleMessage: 'cop.warning.message.title.noauth', errorType: 'No Authorization' },
      { code: '403', message: 'cop.warning.message.content.forbidden', titleMessage: 'cop.warning.message.title.forbidden', errorType: 'Forbidden' },
      { code: '404', message: 'cop.warning.message.content.notFound', titleMessage: 'cop.warning.message.title.notFound', errorType: 'Not Found' },
      { code: '500', message: 'cop.warning.message.content.internalServerError', titleMessage: 'cop.warning.message.title.internalServerError', errorType: 'Internal Server Error' },
      { code: '503', message: 'cop.warning.message.content.outOfResources', titleMessage: 'cop.warning.message.title.outOfResources', errorType: 'Out of Resources' },
    ];

    if (login.includes(this.errorCode)) {
      this.pageDesign = 'login';
    } else if (inactive.includes(this.errorCode)) {
      this.pageDesign = 'inactive';
    } else if (clientServerErrCodes.includes(this.errorCode)) {
      this.pageDesign = 'clientServerErr';
      this.errorType = errList.find(err => err.code === this.errorCode).errorType;
    }

    if (errList.some(err => err.code === this.errorCode)) {
      this.message = SDLUtil.getMsgProp(errList.find(err => err.code === this.errorCode).message);
      this.titleMessage = SDLUtil.getMsgProp(errList.find(err => err.code === this.errorCode).titleMessage);
    }

    RequestUtil
      .get(`${SDLUtil.API_URL}/emptypage/system-property`)
      .then(({ data }) => {
        this.systemEmail = data.systemEmail;
        this.systemTel = data.systemTel;
        this.systemItvoc = data.systemItvoc;
      });

    // else if (errorCode === '404') {
    //   this.message = 'Page not found';
    // }

    //    if (this.pageDesign === 'login') {
    //      document.querySelector('body').classList.add('ui--login-wrap');
    //    } else {
    //      document.querySelector('body').classList.add('sdl-wrap');
    //    }
  },
};
</script>

<style>
span.move_target {
  color:#545DD4;
  text-decoration: underline;
  cursor: pointer;
}
span.move_target:hover {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/view/admin/main/EmptyPage.vue